import React, { useState } from "react";
import { Link } from "gatsby";
import "./navbar.css";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setTimeout(() => {
      setMenuOpen(false);
    }, 100);
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">

        <Link to="/" className="navbar-logo" onClick={closeMenu}>
          SRIVISHNU
        </Link>

        <div
          className="burger-icon"
          role="button"
          tabIndex="0"
          onClick={toggleMenu}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") toggleMenu();
          }}
          aria-expanded={menuOpen}
          aria-label={menuOpen ? "Close menu" : "Open menu"}
        >
          {menuOpen ? "✖" : "☰"}
        </div>

        <ul className={`navbar-links ${menuOpen ? "mobile-menu" : ""}`}>
          <li>
            <Link to="/about" activeClassName="active-link" onClick={closeMenu}>
              About
            </Link>
          </li>
          <li>
            <Link to="/projects" activeClassName="active-link" onClick={closeMenu}>
              Projects
            </Link>
          </li>
          <li>
            <Link to="/resume" activeClassName="active-link" onClick={closeMenu}>
              Resume
            </Link>
          </li>
          <li>
            <Link to="/tools" activeClassName="active-link" onClick={closeMenu}>
              Tools
            </Link>
          </li>
        </ul>

      </div>
    </nav>
  );
};

export default Navbar;